import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "identification"
})
export class IdentificationPipe implements PipeTransform {
  transform(value): string {
    const str = ("" + value).replace(/\D/g, "");

    if (str.length == 11) {
      const match = str.match(/^(\d{3})(\d{7})(\d{1})$/);

      return !match ? null : `${match[1]}-${match[2]}-${match[3]}`;
    } else if (str.length == 9) {
      const match = str.match(/^(\d{3})(\d{5})(\d{1})$/);

      return !match ? null : `${match[1]}-${match[2]}-${match[3]}`;
    }

    return value;
  }
}
